// extracted by mini-css-extract-plugin
export default {"slideshow":"SingleAnswerMultiChoiceQuestion__slideshow___vCJL9","button":"SingleAnswerMultiChoiceQuestion__button___yWjAW"};